interface AuthHeaderProps {
  mode: "signin" | "signup" | "confirmation" | "reset" | "update";
  selectedPlan?: {
    name: string;
  };
}

export const AuthHeader = ({ mode, selectedPlan }: AuthHeaderProps) => {
  return (
    <div className="text-center">
      <img 
        src="/lovable-uploads/b17da96c-24f7-4f7f-97cc-f6e8b3220bbf.png" 
        alt="CSO Agent Logo" 
        className="mx-auto h-12 w-12 mb-4"
      />
      <h1 className="text-4xl font-bold text-gray-900 mb-2">
        {mode === "signin" ? "Welcome Back" : 
         mode === "signup" ? "Create Account" :
         mode === "reset" ? "Reset Password" :
         mode === "update" ? "Update Password" :
         mode === "confirmation" ? "Check Your Email" : ""}
      </h1>
      <p className="text-gray-600 text-lg">
        {mode === "signin" ? "Sign in to continue to CSO Agent" : 
         mode === "signup" ? (selectedPlan ? `Sign up to continue with ${selectedPlan.name} plan` : "Sign up to get started with CSO Agent") :
         mode === "reset" ? "Enter your email to reset your password" :
         mode === "update" ? "Enter your new password" :
         mode === "confirmation" ? "Please check your inbox and click the link to verify your account." : ""}
      </p>
    </div>
  );
};